/* eslint-disable no-unused-vars */
import { AppState, useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { GlobalKeys, PageSpecificKeys, useLocalStorage } from 'helpers/localStorage';
import { PUBLIC_URLS } from 'services/urls';

export enum SignUpType {
    SOCIAL = 'SOCIAL',
}

export interface CustomAppState extends AppState {
    signupType?: SignUpType;
    isDirectSignUpFlow?: boolean;
}

export interface IAuth0SignUpData {
    email?: string;
    given_name?: string;
    family_name?: string;
    sub?: string;
}

export const handleAuthRedirect = (appState?: CustomAppState) => {
    if (appState?.signupType === SignUpType.SOCIAL) {
        localStorage.setItem(GlobalKeys.AppStateBeforeRedirection, JSON.stringify(appState));
    }
    const targetUrl = appState?.returnTo || window.location.pathname;
    window.history.replaceState({}, '', targetUrl);
};

export const HandleNewSocialUser = () => {
    // This component is handles the case when a new user signs up using social login
    const { user } = useAuth0();
    const [_, setSignUpAuth0Data] = useLocalStorage<IAuth0SignUpData>(PageSpecificKeys.SignUpAuth0Data, {});

    useEffect(() => {
        // This effect prepares the sign-up data if the user is a new social login user (useSignUpManager uses this data)
        if (user && user?.email) {
            const appStateStr = localStorage.getItem(GlobalKeys.AppStateBeforeRedirection);
            const storedAppState: CustomAppState | undefined = appStateStr ? JSON.parse(appStateStr) : undefined;

            if (storedAppState?.signupType === SignUpType.SOCIAL) {
                setSignUpAuth0Data({
                    email: user.email,
                    given_name: user.given_name,
                    family_name: user.family_name,
                    sub: user.sub,
                });
                localStorage.removeItem(GlobalKeys.AppStateBeforeRedirection);
                if (storedAppState?.isDirectSignUpFlow) {
                    window.location.replace(PUBLIC_URLS.SIGN_UP.DIRECT_SIGN_UP);
                } else {
                    window.location.replace(PUBLIC_URLS.SIGN_UP.LANDING_PAGE);
                }
            }
        }
    }, [user]);

    return null;
};
